// RigSentinel Context Engine — Phase RCE-1
//
// React hook that returns the current Engineering Session and re-renders
// when it changes (via the RCE event bus or window storage events).

import { useEffect, useState, useCallback } from "react";
import {
  getEngineeringSession,
  setEngineeringSession,
  updateEngineeringSession,
  clearEngineeringSession,
} from "@/lib/rce/session";
import { on, RCE_EVENTS } from "@/lib/rce/events";

export function useEngineeringSession() {
  const [s, setS] = useState(() => getEngineeringSession());

  useEffect(() => {
    const refresh = () => setS(getEngineeringSession());
    const off = on(RCE_EVENTS.ENGINEERING_SESSION_CHANGED, refresh);
    // Cross-tab — listen for storage events too.
    const storageHandler = (e) => {
      if (e.key === "rsc.engSession.v1") refresh();
    };
    window.addEventListener("storage", storageHandler);
    return () => { off(); window.removeEventListener("storage", storageHandler); };
  }, []);

  const set    = useCallback((p) => setS(setEngineeringSession(p)),    []);
  const patch  = useCallback((p) => setS(updateEngineeringSession(p)), []);
  const clear  = useCallback(()  => { clearEngineeringSession(); setS(null); }, []);

  return { session: s, set, patch, clear };
}
